import WebsiteBehaviors from "../website-behaviors/index.js";

class SciHub extends WebsiteBehaviors {
	identifier() {
		return "SciHub";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return window.top === window.self && location.host === "sci-hub.scihubtw.tw";
	}

	// @ts-expect-error TS(2416) FIXME: Property 'topFrameHandler' in type 'SciHub' is not... Remove this comment to see the full error message
	async topFrameHandler() {
		const element = document.querySelector("#citation");
		if (!element)
			return null;

		// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
		return {citation: element.textContent.trim()};
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'processOrgProxy' implicitly has an 'any... Remove this comment to see the full error message
	getPageUrl(processOrgProxy) {
		const element = document.querySelector("#link a");
		if (!element)
			return super.getPageUrl(processOrgProxy);

		const pageUrl = element.getAttribute("href");
		return processOrgProxy(pageUrl);
	}
}

export default SciHub;
